import { render, staticRenderFns } from "./panguSideModal.vue?vue&type=template&id=4dffbd40"
import script from "./panguSideModal.vue?vue&type=script&lang=js"
export * from "./panguSideModal.vue?vue&type=script&lang=js"
import style0 from "./panguSideModal.vue?vue&type=style&index=0&id=4dffbd40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports